module.exports = __webpack_public_path__ + "static/media/ArrowCross.83810b19.svg";